import BaseServiceCrud from "./BaseServiceCrud";

export default class GeoCodingService extends BaseServiceCrud {

    constructor() {
        super();
        this.path = 'geo';
    }
    getCriteria() {
        return this.objToQueryString({});
    }
    getCoordinates(paramsObj){
        const filteredParams = this.createFiltersParams(paramsObj)  
        return this.fetch(`${this.domain}/${this.path}/coordinates?${filteredParams}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    getAddress(paramsObj){
        const filteredParams = this.createFiltersParams(paramsObj)  
        return this.fetch(`${this.domain}/${this.path}/address?${filteredParams}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    createFiltersParams (paramsObj){
        const filteredParams = Object.entries(paramsObj)
        .filter(([key, value]) => value != null && value !== '') 
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)  
        .join('&');
        return filteredParams;
    }
    
}
